module.exports = __webpack_public_path__ + "static/media/user.25e811b9.svg";